import { Tab } from '@headlessui/react'

export const SubHeader = ({
  isDataLoading,
  isMobile,
  currentTab,
  setCurrentTab,
  headerChangeGAEvent,
  tabsCount,
}: any) => {
  const classNames = (...classes: any) => {
    return classes.filter(Boolean).join(' ')
  }

  return (
    <>
      {isDataLoading ? (
        <div className={`${isMobile ? 'mx-5' : ''}`}>
          <div className={`h-[40px] w-full bg-[#dbdbdb52] `}>
            <span className="w-[107px] h-[40px] inline-block bg-[#DBDBDB]"></span>
            <span className="w-[107px] h-[40px] inline-block"></span>
            <span className="w-[107px] h-[40px] inline-block"></span>
          </div>
        </div>
      ) : (
        <Tab.Group as="div">
          <div className={`overflow-x-auto ${isMobile ? 'px-5' : ''}`}>
            <Tab.List
              className={`w-full flex items-center gap-2 ${
                isMobile ? '' : 'border-b border-gray-200'
              } `}
            >
              <Tab
                className={() =>
                  classNames(
                    'p-1 text-sm font-medium whitespace-nowrap outline-none',
                    currentTab == 'all'
                      ? 'border-b-2 border-solid border-orange-600 dark:text-orange-600 text-orange-600'
                      : 'text-[#251000a3]'
                  )
                }
                onClick={() => {
                  setCurrentTab('all')
                  headerChangeGAEvent('all')
                }}
              >
                All
                <sup className={`ml-1 opacity_056`}>{tabsCount.all}</sup>
              </Tab>
              <Tab
                className={() =>
                  classNames(
                    'p-1 text-sm font-medium whitespace-nowrap outline-none',
                    currentTab == 'EBO'
                      ? 'border-b-2 border-solid border-orange-600 dark:text-orange-600 text-orange-600'
                      : 'text-[#251000a3]'
                  )
                }
                onClick={() => {
                  setCurrentTab('EBO')
                  headerChangeGAEvent('EBO')
                }}
              >
                Exclusive Stores
                <sup className={`ml-1 opacity_056`}>{tabsCount.ebo}</sup>
              </Tab>
              <Tab
                className={() =>
                  classNames(
                    'p-1 text-sm font-medium whitespace-nowrap outline-none',
                    currentTab == 'IMPACT'
                      ? 'border-b-2 border-solid border-orange-600 dark:text-orange-600 text-orange-600 '
                      : 'text-[#251000a3]'
                  )
                }
                onClick={() => {
                  setCurrentTab('IMPACT')
                  headerChangeGAEvent('IMPACT')
                }}
              >
                Impact Stores
                <sup className={`ml-1 opacity_056`}>{tabsCount.impact}</sup>
              </Tab>
            </Tab.List>
          </div>
        </Tab.Group>
      )}
    </>
  )
}
